import { render, staticRenderFns } from "./SendReportIcon.vue?vue&type=template&id=5377b85f&"
import script from "./SendReportIcon.vue?vue&type=script&lang=js&"
export * from "./SendReportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports